import { createFileRoute } from "@tanstack/react-router";

import BulkAssessmentQueuePage from "@/features/dashboard/pages/bulk-assessment-queue";

export const Route = createFileRoute("/(app)/dashboard/invoice-queue")({
  component: () => <BulkAssessmentQueuePage />,
});
